import 'vue';
import './helpers.js';
import './config.js';
import { b as registerComponent } from './plugins-6a50b8eb.js';
import './Icon-ea600614.js';
import './FormElementMixin-648192be.js';
import './Input-a080efb8.js';
import { s as script } from './Autocomplete-fe359cd1.js';
export { s as OAutocomplete } from './Autocomplete-fe359cd1.js';

var index = {
    install(app) {
        registerComponent(app, script);
    }
};

export default index;
